import React, { useEffect, useState } from "react";
import { FaFilter, FaPhoneAlt } from "react-icons/fa";
import { geWintWalletTrns } from "../../api/endpoints";
import PageHeader from "../../components/PageHeader";

const WinWalletTransaction = () => {

  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [page, setPage] = useState(1);

  const limit = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [showFilter, setShowFilter] = useState(false);

  const winwalletList = async () => {
    try {

      const params = {
        page,
        limit
      };

      if (search.trim()) {
        params.search = search.trim();
      }

      if (type) {
        params.type = type;
      }


      const res = await geWintWalletTrns(params);

      setTransactions(res.data.transactions || []);
      setTotalPages(res.data.pagination.totalPages || 1);


    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    winwalletList();
  }, [page, search, type]);



  return (

    <div className="lead-page">

      <PageHeader
        title="Win Wallet Transactions"
      />


      <div className="card card-light">

        <div className="card-header d-flex justify-content-between">


          <h5 className="mb-0">
            All Transactions
          </h5>


          <div className="d-flex gap-2">

            {
              showFilter &&
              <>
                <input
                  className="form-control"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => {
                    setPage(1);
                    setSearch(e.target.value)
                  }}
                />


                {/* <select
                  className="form-select"
                  value={type}
                  onChange={(e) => {
                    setPage(1);
                    setType(e.target.value)
                  }}
                >

                  <option value="">
                    All
                  </option>

                  <option value="WIN">
                    Win
                  </option>


                  <option value="BET">
                    Loss
                  </option>


                </select> */}

              </>
            }


            <button
              className="btn btn-dark"
              onClick={() => setShowFilter(!showFilter)}
            >
              <FaFilter />
              Filter
            </button>


          </div>


        </div>



        <div className="card-body">


          <div className="table-responsive">

            <table className="table align-middle">


              <thead>

                <tr>
                  <th>ID</th>
                  {/* <th>User</th> */}
                  <th>User Mobile</th>
                  <th>Referral</th>
                  <th>Game</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Before</th>
                  <th>After</th>
                  <th>Remark</th>
                  <th>Date</th>
                </tr>

              </thead>



              <tbody>


                {
                  transactions.length > 0 ?

                    transactions.map((item, index) => (


                      <tr key={item._id}>


                        <td>
                          {index + 1}
                        </td>


                        {/* <td>

                          {
                            item.userId?.fullName
                              ?
                              item.userId.fullName
                              :
                              "N/A"
                          }

                        </td> */}



                        <td>
                          <FaPhoneAlt size={12} />
                          {" "}
                          {item.userId?.mobile || "N/A"}
                        </td>



                        <td>

                          <span className="badge bg-info">

                            {
                              item.userId?.referralCode || "-"
                            }

                          </span>

                        </td>



                        <td>
                          {item.game}
                        </td>



                        <td>

                          <span
                            className={`badge ${item.type === "WIN"
                                ?
                                "bg-success"
                                :
                                "bg-danger"
                              }`}
                          >

                            {item.type}

                          </span>

                        </td>



                        <td>
                          ₹ {item.amount}
                        </td>



                        <td>
                          ₹ {item.balanceBefore}
                        </td>



                        <td>
                          ₹ {item.balanceAfter}
                        </td>



                        <td>
                          {item.remark}
                        </td>



                        <td>

                          {
                            new Date(item.createdAt)
                              .toLocaleDateString()
                          }

                        </td>



                      </tr>


                    ))

                    :

                    <tr>
                      <td colSpan="11" className="text-center">
                        No Transactions Found
                      </td>
                    </tr>


                }


              </tbody>


            </table>


          </div>



          {/* Pagination */}

          <div className="d-flex justify-content-center gap-2 mt-3">


            <button
              className="btn btn-sm btn-secondary"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>


            <span>
              Page {page} of {totalPages}
            </span>



            <button
              className="btn btn-sm btn-secondary"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >

              Next

            </button>



          </div>


        </div>


      </div>


    </div>

  )

}


export default WinWalletTransaction;